export const apiIp = process.env.REACT_APP_HOST;
